module.exports = __webpack_public_path__ + "static/img/report3d_function05.b445685e.png";